"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { GlobalPageHeader } from "@/components";

function PrivacyPageHeader(): ReactElement {
  const t = useTranslations("legal.PrivacyPageHeader");
  return <GlobalPageHeader title={t("title")} />;
}

export { PrivacyPageHeader };
